import React, { useEffect, useState, useCallback } from "react";

// Bootstrap imports
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Form,
  ListGroup
} from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import * as Icon from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";

// external libraries
import { ThreeCircles } from "react-loader-spinner";
import { getFromLS, setToLS } from '../../../utils/storage';
import Select from "react-select";

// custom imports
import DropFileInput from "../../../reusable-components/DropFileComponent/DropFileComponent"
import { ReportGrid } from "../ReportGrid";
import { Switch } from "../LocalModeSwitch";
import { TemplateDownloadRenderer } from "../TemplateDownloadRenderer";
import OffCanvasNavbar from "../reportNavbar";
// highchart imports
import * as Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import drilldown from "highcharts/modules/drilldown";
import * as HighchartsExporting from 'highcharts/modules/exporting';
import CustomEvents from "highcharts-custom-events";
import { TemplateDescriptionPopover } from "../TemplatePopoverlay";
require("highcharts/modules/accessibility")(Highcharts);
drilldown(Highcharts);
HighchartsExporting(Highcharts);
CustomEvents(Highcharts);
// Highcharts text formatter
Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});

let groupBy = function (array, key) {
  return array.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

function sortByMonth(arr, months) {
  arr.sort(function (a, b) {
    return months.indexOf(a) - months.indexOf(b);
  });
}

// Handling the action context menu
function upsert(array, element) { // (1)
  const i = array.findIndex(_element => _element.text === element.text);
  if (i > -1) array[i] = element; // (2)
  else array.push(element);
}

// Report renderer
const JurisdictionReport = () => {
  // set or declare default report variables

  // set user creds
  const [firm_id, setFirmId] = useState(getFromLS("firmId"));
  const [vendor, setVendor] = useState("xcm"); // This report is specifically only for XCM
  const [isLoading, setIsLoading] = useState(true);
  const localChartTheme = getFromLS("chart-theme");

  // set default API params
  const [reportApiResponse, setReportApiResponse] = useState({
    data: { 0: { report: { data: [], report: [] } } },
  });

  // set local mode params
  const [localApiResponse, setLocalApiResponse] = useState({
    data: { 0: { report: { data: [], report: [] } } },
  });
  const [template_file_list, setTemplateFileList] = useState([]);
  const [templateDescription, setTemplateDescription] = useState("")
  const [localMode, setLocalMode] = useState(false);
  const [localLoaderToggle, setLocalLoaderToggle] = useState(true);

  // Set feature details to control access and get accessible features
  const featureName = "Jurisdictions Report";

  // declare default grid params
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api;
    gridApi.closeToolPanel();
  }, []);

  // declare relevant report data variabled to be displayed, these will be set in the main processing function of the report
  const reportName = "Jurisdiction Report";
  const [activeEmployees, setActiveEmployees] = useState("");
  const [hoursRemaining, setHoursRemaining] = useState("");
  const [reportDate, setReportDate] = useState("");
  const [contextHeader, setContextHeader] = useState("Jan"); // Let default contect of drilled chart be Jan

  // fetch data from Jurisdiction Status Report API
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ firm_id, vendor }),
  };

  const getJurisdictionReportData = () => {
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/jurisdictions/`,
      requestOptions
    )
      // API data recieved
      .then((result) => result.json())
      // API data state maintained
      .then((result) => setApiData(result, false))
      // Maintaining the templatye files sent from API response
      .then((result) => (setTemplateFiles(result)))
  };


  /**
 * In this function we set the API data and change state of chart and grid data. We use the localmode flag to maintain state and switch the chart to Report API data or Local mode API data.
 * @param {*} result: Jurisdictions Report API response or Localmode API of this report.
 * @param {*} localMode: Flag.
 * @returns: API response (for further use).
 */
  const setApiData = (result, localMode = false) => {
    console.log("API DATA: ", result)
    if (localMode) {
      setLocalApiResponse(result);
    } else {
      setReportApiResponse(result);
    }
    // setting data to create required options for dropdown select
    setSelectOptions(result.data[0].report.data);
    gridParamsMapper(result)
    columnChartDataRenderer(result);
    return result;
  };

  /**
 * This function is used for formatting the default column names of the grid
 * @param {*} defaultName: Current name from API
 * @returns: Final column name
 */
  const GridColumnTitleRenderer = (defaultName) => {
    const splitWords = defaultName.split("_")
    for (let word in splitWords) {
      splitWords[word] = splitWords[word].charAt(0).toUpperCase() + splitWords[word].slice(1)
    }
    return splitWords.join(" ")
  }

  /**
   * This function takes the API response data and maps it to the grid params
   * @param {*} result: API response
   */
  const gridParamsMapper = (result) => {
    console.log("GRID PARAM MAPPER RESULT:", result)
    if (result.data[0].report.data.length != 0) {
      const keys = Object.keys(result.data[0].report.report[0]) // You need to change this based on API response format in every report
      let jsonColDefs = keys.map(key => {
        return {
          field: key, headerName: GridColumnTitleRenderer(key)
        }
      });
      setColDefs(jsonColDefs)
    }
    setRowData(result.data[0].report.report);
  }

  /**
   * In this function, we pass the API response to extract template links to be displayed in local mode.
   * @param {*} result: API response.
   * @returns API response (for further use).
   */
  const setTemplateFiles = (result) => {
    const templates = result.data[0].report.templates
    setTemplateFileList(templates)
    const templateDescriptionHolder = []
    for(let template in templates){
      Object.assign(templateDescriptionHolder, {[templates[template].name + templates[template].extension]: templates[template].description})
    }
    setTemplateDescription(templateDescriptionHolder)
    return result
  }

  /**
   * This function enables the local mode and maintains the state of loaders and messages to be displayed.
   */
  const LocalModeEnabler = () => {
    setLocalLoaderToggle(true);
    if (localMode) {
      console.log("LOCAL MODE API RESPONSE: ", localApiResponse)
      setLoaderText(true);
      setApiData(reportApiResponse, false);
      setLocalLoaderToggle(false);
    }
    setLocalMode(!localMode);
  };

  /**
   * This function accepts the uploaded template excel files and adds them to the payload for making Local Mode API call
   * @param {*} files 
   */
  const onFileChange = (files) => {
    const formData = new FormData();
    formData.append("file1", files[0]);
    LocalModeApi(formData)
  };

  /**
   * This function takes the payload of uploaded excel files and makes the Local Mode API call
   * @param {*} formData: Payload.
   */
  const LocalModeApi = (formData) => {
    // updating payload for Local Mode API
    formData.append("report_name", "jurisdiction");
    // This times out the loader till charts are generated
    if (formData) {
      setLoaderText(!loaderText);
      setTimeout(() => {
        setLocalLoaderToggle(false);
      }, 3000);
    }
    // call api and get data
    const requestOptions = {
      method: "POST",
      body: formData,
    };
    console.log("REQUEST OPTIONS: ", requestOptions);
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/local/get_reports/`,
      requestOptions
    )
      // API data recieved
      .then((result) => result.json())
      // Local Mode API data state maintained
      .then((result) => {
        console.log("LOCAL MODE API: ", result)
        if (result.success === true) {
          setLoaderText(!loaderText);
          setApiData(result, true)
          setTimeout(() => {
            setLocalLoaderToggle(false);
          }, 3000);
        } else {
          console.log("FAILED TO LOAD A LOCAL FILE!")
          setLocalLoaderToggle(true);
        }
      }
      ).catch(error => {
        console.error('ERROR IN LOCAL MODE API:', error);
      })
  }

  // declaring and setting default data params for chart
  const [columnChartData, setColumnChartData] = useState({
    name: "Jurisdiction",
    colorByPoint: true,
    data: [],
  })
  const [drilledColumnChartData, setDrilledColumnChartData] = useState({
    name: "Jurisdiction",
    colorByPoint: true,
    data: [],
  })
  const [drilledInfo, setDrilledInfo] = useState({ Jan: [{ NA: {} }] });


  /**
   * This function creates the options for filter dropdown select required in this report.
   * @param {*} reportData: Report data from API.
   */
  const setSelectOptions = (reportData) => {
    let optionsDataHolder = [];
    const filterField = "responsible_person"
    const filterCategoriesData = groupBy(reportData, filterField);
    const filterCategories = Object.keys(filterCategoriesData);
    filterCategories.sort();
    for (let obj in filterCategories) {
      let val = filterCategories[obj];
      let optionObject = {
        value: val,
        label: val,
      };
      optionsDataHolder.push(optionObject);
    }
    setOptionsData(optionsDataHolder);
  };

  let xAxisCategories; // Here the xAxis categories are months.
  /**
   * This is the core function for rendering chart in Jurisdiction Report.
   * @param {*} result : API data
   * @param {*} filterBy : filter to be applied on chart data
   */
  const columnChartDataRenderer = (result, filterBy) => {
    let reportData = result.data[0].report.data;
    // set up the report chip data from API response
    setActiveEmployees(result.data[0].report.current_active_employees);
    setHoursRemaining(result.data[0].report.hours_remain_in_busy_season);
    setReportDate(result.data[0].report.most_recent_report_date);

    const filterField = "responsible_person"
    const xAxisCategoryField = "month_name"
    const xAxisSubCategoryField = "task_status"

    const drilledSubCategoryField = "task_type"
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const columnChartDataHolder = {
      name: "Jurisdiction",
      colorByPoint: true,
      data: [],
    };

    if (filterBy) {
      let data = groupBy(reportData, filterField)[filterBy];
      reportData = data;
      setRowData(reportData);
    }

    const monthCategoriesData = groupBy(reportData, xAxisCategoryField);
    xAxisCategories = Object.keys(monthCategoriesData);
    sortByMonth(xAxisCategories, months); // We need to do a special sort for months because month names cannot be sorted alphabetically
    let xAxisSubCategoriesData = groupBy(reportData, xAxisSubCategoryField);
    let xAxisSubCategories = Object.keys(xAxisSubCategoriesData);

    //  We need data holders to format the data in required syntax.
    let firstTemporaryHolder = {};
    let secondTemporaryHolder = {};
    for (let key in xAxisSubCategories) {
      firstTemporaryHolder[xAxisSubCategories[key]] = [];
      secondTemporaryHolder[xAxisSubCategories[key]] = [];
    }

    // Here we are taking the sub category records and then grouping them based on categories, this is stored in firstTemporaryHolder.
    for (let subCategory in xAxisSubCategoriesData) {
      let subCategoryRecords = xAxisSubCategoriesData[subCategory];
      let monthlyRecords = groupBy(subCategoryRecords, xAxisCategoryField);
      let monthlyRecordHolder = {};
      for (let month in monthlyRecords) {
        let count = 0;
        for (let rec in monthlyRecords[month]) {
          count += monthlyRecords[month][rec].task_count;
        }
        monthlyRecordHolder[month] = count;
      }
      firstTemporaryHolder[subCategory].push(monthlyRecordHolder);
    }

    // now we format the first temporary holder data if there are no records in category group of subcategory records, we set it to zero.
    // i.e. If a task type does not have any monthly record we set its count to 0 instead of NaN this ensures that when we aggregate the count later it wont break 
    for (let field in firstTemporaryHolder) {
      let values = firstTemporaryHolder[field][0];
      if (values != undefined) {
        for (let category in xAxisCategories) {
          if (xAxisCategories[category] in values) {
            values[xAxisCategories[category]] = values[xAxisCategories[category]];
          } else {
            values[xAxisCategories[category]] = 0;
          }
        }
      }
      secondTemporaryHolder[field] = values;
    }

    // here we are formatting the data into the required format for chart
    for (let record in secondTemporaryHolder) {
      let values = secondTemporaryHolder[record];
      let recordHolder = {
        name: record,
        data: [],
      };
      if (values != undefined) {
        for (let month in months) {
          if (Object.keys(values).includes(months[month])) {
            recordHolder["data"].push(values[months[month]]);
          } else {
            recordHolder["data"].push(0);
          }
        }
      }
      columnChartDataHolder["data"].push(recordHolder);
    }
    setColumnChartData(columnChartDataHolder);

    let detailedTaskStatuses = Object.keys(groupBy(reportData, drilledSubCategoryField));
    setDetailedTaskStatusCats(detailedTaskStatuses);

    //  We need data holders to format the drilled data in required syntax same as above
    let firstDrilledRecordsHolder = {};
    let secondDrilledRecordsHolder = {};
    for (let key in xAxisCategories) {
      firstDrilledRecordsHolder[xAxisCategories[key]] = [];
      secondDrilledRecordsHolder[xAxisCategories[key]] = [];
    }
    for (let month in monthCategoriesData) {
      let categoryRecords = monthCategoriesData[month];
      let subCategoryRecordsData = groupBy(categoryRecords, xAxisSubCategoryField);
      let monthlyRecordsHolder = {};
      for (let category in subCategoryRecordsData) {
        let subCategoryRecords = subCategoryRecordsData[category];
        let drilledCategoryRecordsData = groupBy(subCategoryRecords, drilledSubCategoryField);

        for (let drilledRecord in drilledCategoryRecordsData) {
          monthlyRecordsHolder[category] = {
            [drilledRecord]: "",
          };
        }
        for (let drilledRecord in drilledCategoryRecordsData) {
          let count = 0;
          for (let subRecord in drilledCategoryRecordsData[drilledRecord]) {
            count += drilledCategoryRecordsData[drilledRecord][subRecord].task_count;
          }
          monthlyRecordsHolder[category][drilledRecord] = count;
        }
      }
      firstDrilledRecordsHolder[month].push(monthlyRecordsHolder);
    }
    setDrilledInfo(firstDrilledRecordsHolder);
    setToLS("firstDrilledRecordsHolder", firstDrilledRecordsHolder);
    // Now we set default drilled chart with JAN data
    updateDrilledColumnChartData("Jan", detailedTaskStatuses, firstDrilledRecordsHolder);
  };
  const [loaderText, setLoaderText] = useState(false);
  const [detailed_task_status_categories, setDetailedTaskStatusCats] =
    useState();
  const [drilledCategories, setDrilledCategories] = useState([]);

  const updateDrilledColumnChartData = (
    category,
    detailedTaskStatuses,
    drilledInfo
  ) => {
    let month = category;
    if (drilledInfo[month] == undefined) {
      month = Object.keys(drilledInfo)[0];
      setContextHeader(month);
    }
    let data = drilledInfo[month][0];
    let drilledCategories = Object.keys(data);
    setDrilledCategories(drilledCategories);
    const drilledBarChartDat = {
      name: "Due Date",
      colorByPoint: true,
      data: [],
    };
    // We create info holder with object made of categories and corresponding empty lists which are updated below
    let temporaryDrilledInfoHolder = {};
    for (let taskStatus in detailedTaskStatuses) {
      temporaryDrilledInfoHolder[detailedTaskStatuses[taskStatus]] = [];
    }
    for (let taskStatus in detailedTaskStatuses) {
      for (let category in drilledCategories) {
        if (
          detailedTaskStatuses[taskStatus] in data[drilledCategories[category]]
        ) {
          temporaryDrilledInfoHolder[detailedTaskStatuses[taskStatus]].push(
            data[drilledCategories[category]][detailedTaskStatuses[taskStatus]]
          );
        } else {
          temporaryDrilledInfoHolder[detailedTaskStatuses[taskStatus]].push(0);
        }
      }
    }
    for (let cat in detailedTaskStatuses) {
      drilledBarChartDat.data.push({
        name: detailedTaskStatuses[cat],
        data: temporaryDrilledInfoHolder[detailedTaskStatuses[cat]],
      });
    }
    setDrilledColumnChartData(drilledBarChartDat);
  };

  // interactive primary chart
  const primaryOptions = {
    chart: {
      type: "column",
      height: 600,
    },
    title: {
      align: "center",
      text: "Jurisdiction statuses",
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    colors: localChartTheme.colors,
    xAxis: {
      categories: xAxisCategories,
      min: 0,
      max: 5,
      offset: 25,
      tickWidth: 2,
      tickLength: 10,
    },
    scrollbar: {
      enabled: true,
    },

    yAxis: {
      title: {
        text: "No. of tasks",
      },
    },

    plotOptions: {
      column: {
        groupPadding: 0.1,
        pointPadding: 0.1,
        stacking: "normal",
      },
      series: {
        events: {
          click: function (event) {
            event.preventDefault();
            // console.log("click event", event)
          },
          dblclick: function (event) {
            event.preventDefault();
            // console.log("doubleclick event", event.toElement.point.category)
            let di = getFromLS("firstDrilledRecordsHolder");
            setContextHeader(event.toElement.point.category);
            updateDrilledColumnChartData(
              event.toElement.point.category,
              detailed_task_status_categories,
              di
            );
          },
          contextmenu: function (event) {
            event.preventDefault();
            // console.log("rightclick event", event.srcElement.point.category)
            let di = getFromLS("firstDrilledRecordsHolder");
            updateDrilledColumnChartData(
              event.srcElement.point.category,
              detailed_task_status_categories,
              di
            );
          },
        },
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span> <b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [
          {
            max: null,
          },
        ],
      },
    },
    series: columnChartData.data,
  };

  const drilledOptions = {
    chart: {
      type: "column",
      height: 600,
    },
    title: {
      align: "center",
      text: " Details of task types for the month of " + contextHeader,
    },
    scrollbar: {
      enabled: false,
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    colors: localChartTheme.colors,
    xAxis: {
      categories: drilledCategories,
      offset: 25,
      tickWidth: 2,
      tickLength: 10,
    },
    yAxis: {
      title: {
        text: "No. of tasks",
      },
    },
    legend: {
      itemStyle: {
        textOutline: false,
        color: "var(--text_color)",
      },
      maxHeight: 100,
    },
    plotOptions: {
      column: {
        groupPadding: 0.1,
        pointPadding: 0.1,
        stacking: "normal",
      },
    },

    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span> <b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [
          {
            max: null,
          },
        ],
      },
    },
    series: drilledColumnChartData.data,
  };

  const [optionsData, setOptionsData] = useState([
    { value: "month", label: "Month" },
  ]);

  const handleSelect = (selected) => {
    let value = selected.value;
    columnChartDataRenderer(reportApiResponse, value);
  };

  // reset functionality
  const handleReset = (flag = false) => {
    if (flag) {
      setRowData(localApiResponse.data[0].report.report);
      columnChartDataRenderer(localApiResponse);
    } else {
      setRowData(reportApiResponse.data[0].report.report);
      columnChartDataRenderer(reportApiResponse);
    }
  };

  // grid export functionality
  const onBtExcelExport = useCallback(() => {
    gridApi.exportDataAsExcel();
  }, []);

  const onBtCSVExport = useCallback(() => {
    gridApi.exportDataAsCsv();
  }, []);


  // loader awaiting api response and page renderx
  const loader = reportApiResponse && columnChartData.data != [] && drilledColumnChartData.data != [];

  // we are adding this buffer timeout for the charts to render before appearing
  useEffect(() => {
    if (loader) {
      setIsLoading(false);
      setTimeout(() => {
        setLocalLoaderToggle(false);
        setLoaderText(true);
      }, 2000);
    }
  }, [loader]);


  // Loading data for the first time.
  if (isLoading) {
    getJurisdictionReportData()
  }

  return (
    <>
      <div className="row-wrapper">
        <div className="row-container">
          {localMode ? (
            <>
              <h3 className="intelligence-report-name">{reportName}</h3>
              <Row className="local-import-row">
                <Col md={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <p style={{ color: "#000", fontWeight: "900", marginBottom: 10, marginRight: 20 }}> Download templates
                    <TemplateDescriptionPopover
                      description={templateDescription}
                    />
                  </p>
                  <Row className="no-gutter">
                    {
                      template_file_list && template_file_list.map((object, index) => (
                        <TemplateDownloadRenderer info={object} key={index} />
                      )
                      )
                    }
                  </Row>
                </Col>
                {
                  template_file_list && template_file_list.map((index) =>
                    <Col md={10 / template_file_list.length} key={index}>
                      <DropFileInput onFileChange={(files) => onFileChange(files)} />
                    </Col>
                  )
                }
              </Row>
            </>
          ) : (
            <>
              <h3 className="intelligence-report-name">Jurisdiction Report</h3>
              <Row className="report-card-row">
                <div className="report-card">
                  <div className="chip-header">Active employees</div>
                  <div className="chip-body">{activeEmployees}</div>
                </div>
                <div className="report-card">
                  <div className="chip-header">
                    Hours remaining in busy season
                  </div>
                  <div className="chip-body">{hoursRemaining}</div>
                </div>
                <div className="report-card">
                  <div className="chip-header">Most recent report date</div>
                  <div className="chip-body">{reportDate}</div>
                </div>
              </Row>
            </>
          )}
        </div>
      </div>

      <div className="row-wrapper">
        <div className="row-container">
          <Tabs
            defaultActiveKey="chart"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="chart" title="Chart" className="tabs">
              <OffCanvasNavbar
                localtoggle={
                  <ButtonGroup>
                    <div className="toggler">
                      {localMode ? (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Go back online
                        </p>
                      ) : (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Switch to local mode
                        </p>
                      )}
                    </div>
                    <div className="toggler">
                      <Switch
                        isToggled={localMode}
                        onClick={() => LocalModeEnabler()}
                      ></Switch>
                    </div>
                  </ButtonGroup>
                }
                secondtoggle={
                  localMode ? (
                    <DropdownButton
                      as={ButtonGroup}
                      onClick={() => handleReset(true)}
                      className="reset-button"
                      title=" Reset"
                    ></DropdownButton>
                  ) : (
                    <DropdownButton
                      as={ButtonGroup}
                      onClick={() => handleReset()}
                      className="reset-button"
                      title=" Reset"
                    ></DropdownButton>
                  )

                }
                selectfirst={
                  <Select
                    options={optionsData}
                    aria-label="Filter"
                    closeMenuOnSelect={true}
                    placeholder="Filter by"
                    defaultValue={"Filter by"}
                    menuPosition="fixed"
                    onChange={(e) => handleSelect(e)}
                  />}
              />

              <Row>
                <Col md="6" className="chart-holder">
                  {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                    <div className="chart-container">
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={primaryOptions}
                      />
                    </div>
                  )}
                </Col>
                <Col md="6" className="chart-holder">
                  {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                    <div className="chart-container">
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={drilledOptions}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="grid" title="Grid" className="tabs">
              <DropdownButton
                as={ButtonGroup}
                className="reset-button download-excel"
                title=" Export"
                id="bg-nested-dropdown"
                drop="start"
              >
                <Dropdown.Item onClick={onBtExcelExport}>
                  {" "}
                  <Icon.FileExcel /> Excel Export
                </Dropdown.Item>
                <Dropdown.Item onClick={onBtCSVExport}>
                  {" "}
                  <Icon.FiletypeCsv /> CSV Export
                </Dropdown.Item>
              </DropdownButton>
              <Row>
                <Col md="12" className="grid-row staffing">
                  <ReportGrid
                    rowData={rowData}
                    colDefs={colDefs}
                    onGridReady={onGridReady}
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default JurisdictionReport;
